export default "__VITE_ASSET__CBrATek___"